import styled, { keyframes } from 'styled-components'

const animateGlow = keyframes`
  0%{background-position:0% 50%}
  50%{background-position:100% 50%}
  100%{background-position:0% 50%}
`
export const TimelineContainer = styled.section`
  display: flex;
  flex-direction: column;
  gap: 48px;
  width: 100%;
  max-width: 1170px;
  position: relative;

  .title-timeline {
    width: 100%;
    max-width: 631px;
  }

  &::before {
    content: '';
    display: block;
    z-index: -1;

    position: absolute;
    bottom: 25%;
    right: 12%;

    width: 20%;
    height: 20%;

    animation: ${animateGlow} 7s ease-in-out infinite;
    background: linear-gradient(270deg, #08eddc, #09a8fa);
    background-size: 200% 200%;

    will-change: transform;
    filter: blur(133px);

    @media (max-width: 900px) {
      bottom: 0;
      right: 40%;
    }
    @media (max-width: 500px) {
      width: 30%;
      height: 30%;
    }
  }

  @media (max-width: 1180px) {
    padding: 0 16px;
  }

  @media (max-width: 900px) {
    align-items: center;
  }

  @media (max-width: 500px) {
    .title-timeline {
      text-align: center;
    }
  }
  @media (max-height: 750px) {
    gap: 24px;
  }
`
export const TimelineList = styled.div`
  display: flex;
  align-items: center;
  gap: 72px;
  width: 100%;

  .list {
    width: 100%;
    max-width: 624px;
    display: flex;
    flex-direction: column;
    gap: 32px;
    position: relative;

    &::after {
      content: '';
      position: absolute;
      height: 90%;
      width: 4px;
      left: 0.9rem;
      top: 0;
      background-color: #08eddc;
    }

    .item {
      position: relative;
      display: flex;
      padding-left: 48px;

      &::before {
        content: '';
        position: absolute;
        height: 32px;
        width: 32px;
        left: 0;
        top: 0;
        border-radius: 100px;
        background-color: ${({ theme }) => theme.colors.primary};
      }
    }
    @media (max-width: 500px) {
      .item {
        padding-left: 24px;
        .title-list {
          font-size: 12px;
          line-height: 18px;
        }
        &::before {
          height: 16px;
          width: 16px;
        }
      }

      &::after {
        height: 92%;
        width: 2px;
        left: 0.45rem;
      }
    }
    @media (max-height: 750px) {
      &::after {
        height: 95%;
        width: 2px;
        left: 0.45rem;
      }
      .item {
        padding-left: 24px;
        &::before {
          height: 16px;
          width: 16px;
        }
      }
    }
  }

  img {
    width: 100%;
    height: 100%;
    max-width: 425px;
    max-height: 425px;
    position: relative;

    @media (max-width: 500px) {
      max-width: 274px;
      max-height: 274px;
    }
  }

  @media (max-width: 900px) {
    flex-direction: column;
    align-items: center;
  }
`
